import { FadeUp } from "./Reveal";

const REVIEWS = [
  {
    name: "Maria G.",
    area: "Stone Oak",
    text: "Cleared a half-acre lot full of brush and dead trees in one day. Showed up early, worked hard, hauled everything off. Best price I got too.",
  },
  {
    name: "Derrick L.",
    area: "Alamo Heights",
    text: "Put in a new gravel driveway after the rains tore mine up. Graded it perfect, no more puddles. Polite crew and they cleaned up after.",
  },
  {
    name: "Jenna P.",
    area: "NW San Antonio",
    text: "Demoed an old shed and hauled off all the debris plus junk in the garage. Quoted fair, showed up on time. Easy start to finish.",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="py-28 md:py-40 bg-[#FFFFFF] text-[#111613]"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <FadeUp>
          <div className="mb-16 md:mb-20">
            <div className="chapter-line text-[#0E2A1A] mb-6">
              Ch. 06 · Kind Words
            </div>
            <h2
              className="font-display text-[#0E2A1A] text-6xl sm:text-7xl md:text-8xl leading-[0.92] tracking-[-0.03em] max-w-4xl"
              style={{ fontWeight: 400 }}
            >
              San Antonio{" "}
              <span className="italic text-[#DA7B3C]">talks.</span>
              <br />
              We listen.
            </h2>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-[#111613]/20">
          {REVIEWS.map((r, idx) => (
            <FadeUp key={r.name} delay={idx * 0.1}>
              <article
                data-testid={`review-card-${idx}`}
                className={`p-8 md:p-12 h-full border-b md:border-b-0 border-[#111613]/20 ${
                  idx !== REVIEWS.length - 1 ? "md:border-r" : ""
                }`}
              >
                <div
                  className="text-7xl md:text-8xl font-display text-[#DA7B3C] leading-none mb-4 italic"
                  style={{ fontWeight: 400 }}
                >
                  &ldquo;
                </div>
                <p
                  className="font-display text-xl md:text-2xl italic leading-snug mb-8 text-[#111613]/90"
                  style={{ fontWeight: 400 }}
                >
                  {r.text}
                </p>
                <div className="pt-6 border-t border-[#111613]/20 flex items-center justify-between">
                  <div>
                    <div className="font-display text-xl md:text-2xl tracking-[-0.02em] text-[#0E2A1A]">
                      {r.name}
                    </div>
                    <div className="font-mono-sm text-[#6B7A6E] mt-1">
                      {r.area}
                    </div>
                  </div>
                  <div className="font-mono-sm text-[#DA7B3C]">★★★★★</div>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
